var exports = {
  "kL": "DiscoverySidebar.module__container___RGJJSU",
  "CT": "DiscoverySidebar.module__navList___RGJJSU",
  "pc": "DiscoverySidebar.module__navItem___RGJJSU",
  "HW": "DiscoverySidebar.module__navItemActive___RGJJSU",
  "T1": "DiscoverySidebar.module__navItemDisabled___RGJJSU",
  "wz": "DiscoverySidebar.module__navItemIcon___RGJJSU",
  "hk": "DiscoverySidebar.module__navItemLabel___RGJJSU",
  "WG": "DiscoverySidebar.module__comingSoonBadge___RGJJSU",
};

module.exports = exports;
